export default {
  en: {
    title: 'No rush',
    subtitle: "We'll check your level whenever you like — it only takes a couple of minutes",
  },
  ru: {
    title: 'Без спешки',
    subtitle: 'Уровень проверим, когда захочешь — это займёт пару минут',
  },
  de: {
    title: 'Keine Eile',
    subtitle: 'Wir prüfen dein Niveau, wann du willst — das dauert nur ein paar Minuten',
  },
  pt: {
    title: 'Sem pressa',
    subtitle: 'Avaliamos seu nível quando você quiser — leva só alguns minutos',
  },
  fr: {
    title: 'Rien ne presse',
    subtitle: 'On vérifiera ton niveau quand tu veux — ça prend deux minutes',
  },
  es: {
    title: 'Sin prisa',
    subtitle: 'Comprobaremos tu nivel cuando quieras — solo lleva un par de minutos',
  },
};
